import { queryOptions, useQuery } from '@tanstack/react-query';

import { chatSettingsApi } from '../api/chat-settings-api';

import { chatSettingsKeys } from './chat-settings-keys';

export function chatProfileQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: chatSettingsKeys.profile(storeId),
    queryFn: () => chatSettingsApi.profile(storeId),
  });
}

/** How the signed-in member appears to this store's shoppers. */
export function useChatProfile(storeId: string) {
  return useQuery(chatProfileQueryOptions(storeId));
}
